module.exports = __webpack_public_path__ + "static/media/casesInactive.056c45f7.svg";